import { Alert } from '@/components/alert';
import { Flex } from '@/components/layouting';
import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { RecoveryMethod as messages } from '../messages';
import { Typography } from '@/components/typography';
import { Icon } from '@/components/icon';
import { LostDeviceStep } from '../enums/lost-device-step';
import { ButtonAnt } from '@/components/buttons/button/ButtonAnt';
import { AuthContentLayout } from '@/routes/auth/components/AuthContentLayout';

const { Paragraph } = Typography;

interface RecoveryMethodContentProps {
  onStepChange: (step: LostDeviceStep) => void;
}

export const RecoveryMethodContent: FC<RecoveryMethodContentProps> = ({ onStepChange }) => {
  return (
    <AuthContentLayout
      alert={<Alert showIcon type="info" description={<FormattedMessage {...messages.alertMessage} />} />}
      paragraph={
        <Paragraph style={{ textAlign: 'center' }}>
          <FormattedMessage {...messages.description} />
        </Paragraph>
      }
      actions={
        <Flex gap={8} vertical>
          <ButtonAnt block onClick={() => onStepChange(LostDeviceStep.RecoveryCode)} size="large" type="primary">
            <FormattedMessage {...messages.haveRecoveryCode} />
          </ButtonAnt>
          <ButtonAnt block onClick={() => onStepChange(LostDeviceStep.MissingCode)} size="large">
            <FormattedMessage {...messages.doNotHaveRecoveryCode} />
          </ButtonAnt>
        </Flex>
      }
    >
      <Icon $fontSize="80px" iconString="mobileButton" />
    </AuthContentLayout>
  );
};
